import type { StartupProfileData } from '@/features/profiles/api/startup-profile.api';
import { useCountries } from '@/hooks/useCountries';
import { useStates } from '@/hooks/useStates';
import type { CreateStartupFormValues } from '../schema';
import { toReviewProfileData } from '../review-profile.mapper';
import { useSectors } from './useSectors';

/**
 * The wizard's current values as a saved-profile shape, with sector and HQ ids
 * resolved to names from the (prefetched, cached) reference data.
 */
export function useReviewProfileData(values: CreateStartupFormValues): StartupProfileData {
  const { data: sectors = [] } = useSectors();
  const { data: countries = [] } = useCountries();
  // Raw watch() state: the id may still be a string, or blank.
  const countryId = Number(values.hqCountryId) || undefined;
  const { states } = useStates(countryId);
  return toReviewProfileData(values, { sectors, countries, states });
}
